import { Flex, Image, Text } from "rebass/styled-components";
import styled from "styled-components";
const { REACT_APP_S3_CLIP_BUCKET } = process.env;
export const BetaCallout = () => {
  return (
    <StyledFlex>
      <BetaPill
        src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/matchHistory/BetaPill.svg`}
      />
      <Text color="ice" variant="text.labelSmall">
        Match History for Fortnite is currently in Beta and only supports
        Tournament Play. Players must finish in the Top 100 in the tournament to
        access their matches. Please look out for bugs and{" "}
        <StyledLink
          href="https://help.allstar.gg/hc/en-us/requests/new"
          target="_blank"
          rel="noopener noreferrer"
        >
          report them to support
        </StyledLink>{" "}
        or our Discord server.
      </Text>
    </StyledFlex>
  );
};

const StyledFlex = styled(Flex)`
  align-items: center;
  background: linear-gradient(319.71deg, #a464da 0%, #f66e86 100%);
  border-radius: 8px;
  gap: 16px;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  width: 100%;
`;

const BetaPill = styled(Image)`
  flex-shrink: 0;
  height: 24px;
  width: 45px;
`;

const StyledLink = styled.a`
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: all 0.1s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.colors.envy};
    text-decoration-color: ${({ theme }) => theme.colors.envy};
  }
`;
